import styled from 'styled-components';
import { Flex, MarginBox } from 'UI';

export const CartNotificationResultWrapper = styled.div`
  width: 100%;
  margin-bottom: -20px;
`;

export const CartStepHeaderWrapper = styled(Flex)`
  width: 100%;
`;

export const CartStepContentWrapper = styled(MarginBox)`
  display: flex;
  justify-content: center;
  width: calc(100% - 30px);
`;
